import { createTheme } from "@mui/material";
import { CRIMSON_RED, DARK_BLUE } from "../../enums/Colors";
import { CHIP_MIN_WIDTH } from "../../enums/Styles";
const base_color = DARK_BLUE;
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: base_color,
    },
    secondary: {
      main: "#fff",
    },
    info: {
      main: base_color,
    },
    warning: {
      main: "#fb8500",
    },
    error: {
      main: CRIMSON_RED,
    },
    background: {
      default: "#f4f6f8",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ".MuiButton-root.Mui-button-positive": {
          //made with higher specificity so it applies
          marginTop: "8px",
          flexShrink: 0,
          fontSize: "0.875rem",
        },
        ".MuiButton-root.Mui-button-negative": {
          marginTop: "8px",
          flexShrink: 0,
          fontSize: "0.875rem",
        },
        ".MuiButton-root.Mui-button-next": {
          marginTop: "8px",
          flexShrink: 0,
          fontSize: "0.875rem",
        },
        ".MuiButton-root.Mui-button-back": {
          marginTop: "8px",
          flexShrink: 0,
          fontSize: "0.875rem",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderColor: base_color,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          background: base_color,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          // MUI zeroes the top padding under a DialogTitle, and the content scrolls,
          // so a focused field's floating label on the first row got clipped
          ".MuiDialogTitle-root + &": {
            paddingTop: 12,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#f9f9f9",
          "&.Mui-blue-colored": {
            backgroundColor: base_color,
            color: "#fff",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          "&.Mui-fullscreen-icon": {
            color: base_color,
            fontSize: "80px",
          },
          "&.Mui-confirmation-dialog-icon": {
            color: base_color,
            fontSize: "120px",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: 1,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          color: "#000000",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            // Styles for the selected chip
            backgroundColor: base_color,
            color: "#fff",
          },
          "&.Mui-error": {
            backgroundColor: CRIMSON_RED,
            color: "#fff",
          },
          "&.Mui-selected .MuiChip-icon": {
            // Customize the icon when the chip is selected
            color: "#fff", // Change icon color
          },
          padding: 2,
          justifyContent: "start",
          "&.MuiChip-colorPrimary": {
            backgroundColor: base_color,
            color: "#fff",
          },
          "&.MuiChip-colorSecondary": {
            backgroundColor: base_color,
            color: "#fff",
          },
          "&.MuiChip-outlined": {
            backgroundColor: base_color,
            color: "#000",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: base_color,
        },
      },
    },
  },
});
